module.exports = __webpack_public_path__ + "img/diagnose2.61433761.jpg";